import { render, staticRenderFns } from "./switchLayoutTwoDialog.vue?vue&type=template&id=117b2ad3&"
import script from "./switchLayoutTwoDialog.vue?vue&type=script&lang=js&"
export * from "./switchLayoutTwoDialog.vue?vue&type=script&lang=js&"
import style0 from "./switchLayoutTwoDialog.vue?vue&type=style&index=0&id=117b2ad3&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports